
export function setTypeContact(state, type_contact) {
    state.type_contact = type_contact;
}



// WEBPACK FOOTER //
// ./src/modules/update-withholdings/mutations.js